/* Timo's story copy, French.
 *
 * This is a retelling, not a translation of story.en.js. Every line here is
 * spoken out loud by Timo, so write it the way it should sound, not the way
 * it should look.
 *
 * How it plays: the story is five chapters. Each chapter is ONE text to
 * speech call, composed as
 *     [celebration or encouragement for the last word] + [chapter] + [invitation]
 * so the whole story costs five calls. That matters: the TTS layer allows
 * five calls per sixty seconds before it locks out, and caps a single call
 * at 2500 characters and silently truncates past it. Keep every chapter
 * between 500 and 700 characters and the composed line stays safe.
 *
 * Two refrains repeat word for word on purpose. A child joins in by the
 * third time they hear them, and joining in is the whole point:
 *     Timo écoute. Timo attend. Timo aide.
 *     Dis-le avec moi, dit Timo.
 * Do not vary them for style. Sameness is the feature.
 *
 * The four target words are what the CHILD is asked to say. They were picked
 * to be the easiest words in their own chapter for a French speaking child
 * with a speech delay: maison, noix, eau, lune. Open syllables, early
 * developing sounds (m, n, l, plus simple vowels), no consonant clusters.
 * heureux was rejected for the r and chapter four was rewritten around the
 * moon instead. Do not swap one for a nicer word.
 *
 * No dashes anywhere in this file. French dialogue normally takes an em
 * dash, so speech here is written with a comma and no quotation marks and
 * no guillemets. It is read by a machine, not printed.
 */

const storyFr = {
  'story.title': "La forêt verte de Timo",
  // Timo hands the telling over to Hoppy, then the recorded story plays.
  'story.handoff': "Hé! Je vais demander à mon ami Hoppy de la raconter.",

  // ==== Chapitre 1 : qui est Timo ====
  'story.ch1':
    "Timo habite dans une grande forêt verte. Timo est petit. Timo a une queue douce avec des rayures. " +
    "Timo a de grandes oreilles toutes rondes. Les grandes oreilles servent à écouter. " +
    "Beaucoup d'animaux habitent dans la forêt. Il y a un grand ours tout lent. Il y a un petit oiseau. " +
    "Il y a deux écureuils très gourmands. Tout le monde parle en même temps. Il y a beaucoup de bruit. " +
    "Mais Timo ne parle pas le premier. Timo écoute. Timo attend. Timo aide. " +
    "La forêt, c'est sa maison. Sa maison est un trou tout doux dans un vieil arbre. " +
    "Le soir, Timo rentre à la maison et il regarde la lune.",

  // ==== Chapitre 2 : les deux écureuils ====
  'story.ch2':
    "Un jour, les deux écureuils ont trouvé une noix. C'était une grosse noix toute brune. " +
    "Les deux écureuils voulaient cette noix. Le premier tirait la noix d'un côté. " +
    "Le deuxième tirait la noix de l'autre côté. Ils ne disaient pas un mot. Ils tiraient et tiraient. " +
    "Alors Timo est arrivé et il s'est assis à côté d'eux. Timo écoute. Timo attend. Timo aide. " +
    "Puis Timo a dit, dis-moi ce que tu veux. Dis-le avec moi, dit Timo. " +
    "Le premier écureuil a dit, je veux la noix. Le deuxième écureuil a dit, moi aussi je veux la noix. " +
    "Maintenant on le sait, dit Timo. La noix est pour vous deux. " +
    "Alors ils ont partagé la noix en deux. Les deux écureuils étaient contents.",

  // ==== Chapitre 3 : le petit oiseau, le coeur de l'histoire ====
  'story.ch3':
    "Ensuite, le petit oiseau est arrivé. Il s'est posé sur une branche basse. " +
    "Il avait chaud et il avait soif. L'oiseau voulait quelque chose, mais le mot ne sortait pas. " +
    "Il a ouvert son bec. Rien n'est sorti. Il a regardé ses pattes. Personne ne l'a pressé. " +
    "Timo écoute. Timo attend. Timo aide. Timo s'est assis à côté de lui un long moment tout calme. " +
    "Puis Timo a dit le mot en premier, tout doucement. Eau. Dis-le avec moi, dit Timo. " +
    "L'oiseau a essayé. Il a essayé encore. Eau. Il l'a dit ! Il a dit eau ! " +
    "Timo a sauté de joie. Toute la forêt verte a applaudi le petit oiseau.",

  // ==== Chapitre 4 : la forêt change, Timo entend les enfants ====
  'story.ch4':
    "Depuis ce jour, la forêt a changé. Quand l'ours voulait une baie, il disait baie. " +
    "Quand les écureuils voulaient jouer, ils disaient jouer. Quand l'oiseau avait soif, il disait eau. " +
    "Personne ne tirait. Personne ne poussait. Tout le monde avait un mot. Timo était content. " +
    "Toute la forêt était contente. Un soir, Timo s'est assis sur sa pierre bien chaude. " +
    "Il a regardé la lune. La lune était grande et toute ronde. La lune éclairait toute la forêt. " +
    "Puis Timo a entendu quelque chose de nouveau. Très loin, derrière les arbres, il y avait des enfants. " +
    "Ces enfants avaient de grandes choses à raconter. " +
    "Mais les mots restaient à l'intérieur. Timo est resté tranquille. Timo a pensé au petit oiseau.",

  // ==== Chapitre 5 : Timo vient jusqu'à l'enfant ====
  'story.ch5':
    "Le matin, Timo a préparé un petit sac. Il a dit au revoir au grand ours tout lent. " +
    "Il a dit au revoir aux deux écureuils. Il a dit au revoir au petit oiseau. " +
    "L'oiseau lui a chanté une chanson, et la chanson avait beaucoup de mots dedans. " +
    "Puis Timo est sorti de la grande forêt verte. Il a marché très, très longtemps. " +
    "Il a gardé ses grandes oreilles bien ouvertes tout le temps. Timo écoute. Timo attend. Timo aide. " +
    "Et un jour, très loin de la forêt, il t'a entendu, toi. Alors me voici. " +
    "Je ne suis plus dans la forêt. Je suis ici, avec toi. " +
    "Et toi, tu as de grandes choses à dire. J'aimerais beaucoup les entendre.",

  // ==== Les quatre invitations : ce que l'enfant dit à voix haute ====
  'story.invite1': "La grande forêt verte, c'est la maison de Timo. Dis maison avec moi.",
  'story.invite2': "Une grosse noix pour deux amis. Dis noix avec moi.",
  'story.invite3': "Le petit oiseau a trouvé son mot. Dis eau avec moi.",
  'story.invite4': "Timo a regardé la grande lune toute ronde. Dis lune avec moi.",

  // ==== Les quatre mots cibles ====
  'story.word1': 'maison',
  'story.word2': 'noix',
  'story.word3': 'eau',
  'story.word4': 'lune',

  // ==== Si l'enfant le dit ====
  'story.celebrate1': "Maison ! Tu l'as dit, et mes grandes oreilles ont bougé de joie.",
  'story.celebrate2': "Noix ! C'était très joli. Les deux écureuils te font coucou.",
  'story.celebrate3': "Eau ! Tu l'as dit comme l'oiseau. Je suis très fier de toi.",
  'story.celebrate4': "Lune ! C'est très beau. La lune brille pour toi aussi.",

  // ==== Si l'enfant ne le dit pas, l'histoire continue aussi joyeusement ====
  'story.encourage1': "Maison, maison, la forêt verte est ma maison. Viens rencontrer mes amis.",
  'story.encourage2': "Noix, noix, une grosse noix partagée en deux. Viens rencontrer le petit oiseau.",
  'story.encourage3': "Eau, eau, une gorgée d'eau bien fraîche. Viens voir ce qui est arrivé après.",
  'story.encourage4': "Lune, lune, la lune éclaire toute la forêt. Viens avec moi jusqu'à la fin.",

  'story.ending':
    "Reviens demain et je te raconterai l'histoire de l'ours et de la toute dernière baie. Bonne nuit, dors bien.",
};

export default storyFr;
